import { Slider } from './slider.js';

let RangeSlider = {
  ...Slider
};

export { RangeSlider };
